import React from 'react';
import { motion } from 'framer-motion';
export function Nav() {
  return <motion.nav initial={{
    y: -20,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 0.8,
    ease: [0.16, 1, 0.3, 1]
  }} className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-6 py-4 backdrop-blur-md bg-[#0a0a0b]/80 border-b border-white/5" data-id="element-102">
      <div className="flex items-center gap-2" data-id="element-103">
        <div className="w-2 h-2 rounded-full bg-amber-400 shadow-[0_0_10px_rgba(251,191,36,0.5)]" data-id="element-104" />
        <span className="text-sm font-bold tracking-widest text-zinc-100 uppercase" data-id="element-105">
          Luca Reyes
        </span>
      </div>

      <div className="hidden md:flex items-center gap-8 text-sm font-medium text-zinc-400" data-id="element-106">
        <a href="#historia" className="hover:text-zinc-100 transition-colors" data-id="element-107">
          Historia
        </a>
        <a href="#expertise" className="hover:text-zinc-100 transition-colors" data-id="element-108">
          Expertise
        </a>
        <a href="#mision" className="hover:text-zinc-100 transition-colors" data-id="element-109">
          Misión
        </a>
      </div>

      <a href="https://www.skool.com/affiliatewave/about?ref=32124321f1d54df7b2eef01cab5ffbf9" target="_blank" rel="noopener noreferrer" className="px-5 py-2 text-sm font-medium text-[#0a0a0b] bg-amber-400 rounded-full hover:bg-amber-300 transition-colors shadow-[0_0_15px_rgba(251,191,36,0.2)]" data-id="element-110">
        Empezar
      </a>
    </motion.nav>;
}